
export default () => {
    const bodyTag = document.querySelector('body')
    const container = document.querySelector('.read-single-colour')
    
    bodyTag.style.backgroundColor = container.getAttribute('data-rgb')   
}